import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Typography,
} from '../../../../../components/mui/Core/index'
import { useTheme } from '../../../../../components/mui/Styles/index'
import { adHocReportingConstants } from '../../../../../constants/ad-hoc-reporting'
import Ellipse from '../../../../../components/genericcomponents/Ellipse/ellipse'

const CenteredContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
}))

function AdHocReportModal({ reportingRedirectUrl, toggleModal }) {
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(true)

  const handleCloseModal = () => {
    setIsOpen(false)
    toggleModal()
  }

  const handleRunAdHocReport = () => {
    window.open(reportingRedirectUrl, '_blank', 'rel=noopener noreferrer')
    handleCloseModal()
  }

  const adHocStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: theme.palette.common.white,
    boxShadow: 24,
    p: 4,
    border: 'none !important',
    borderRadius: '12px',
    padding: '10px 24px',
  }

  const modalTitle = {
    fontSize: '25px',
    color: `${theme.palette.primary.main}`,
    fontFamily: 'SanomatMedium',
    letterSpacing: 'normal',
    marginBottom: '15px',
  }

  const listTextStyle = {
    color: theme.palette.common.black,
    fontFamily: 'AtlasGroteskRegular',
    fontSize: '16px',
    lineHeight: '20px',
  }

  const modalButtonsBoxStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  }

  const adHocModalStyle = {
    letterSpacing: '1.28px',
    padding: theme.spacing(0, 6),
    margin: '20px 0 10px 10px',
  }

  const adhocReportListStyle = {
    paddingTop: '10px',
    paddingBottom: '15px',
    '& li': {
      paddingBottom: '0px',
      paddingTop: '0px',
      '& .MuiListItemIcon-root': {
        alignSelf: 'flex-start',
        minWidth: '15px',
        paddingTop: '12px',
      },
      '& .MuiListItemText-root': {
        marginTop: '5px',
        marginBottom: '15px',
      },
    },
  }

  return (
    <Modal onClose={() => setIsOpen(false)} open={isOpen}>
      <CenteredContainer>
        <Box sx={adHocStyle}>
          <Typography sx={modalTitle}>
            {adHocReportingConstants.title.ADHOC_REPORTING_MODAL}
          </Typography>
          <Typography sx={listTextStyle}>
            {adHocReportingConstants.message.ADHOC_REPORTING_REDIRECT_NOTICE}
          </Typography>
          <List sx={adhocReportListStyle}>
            <ListItem disablePadding>
              <ListItemIcon>
                <Ellipse />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={listTextStyle}
                primary={adHocReportingConstants.message.AHDOC_REPORTING_REDIRECT_NOTE_1}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemIcon>
                <Ellipse />
              </ListItemIcon>
              <ListItemText
                // TODO: fix this
                primaryTypographyProps={listTextStyle}
                primary={adHocReportingConstants.message.AHDOC_REPORTING_REDIRECT_NOTE_2}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemIcon>
                <Ellipse />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={listTextStyle}
                primary={adHocReportingConstants.message.AHDOC_REPORTING_REDIRECT_NOTE_3}
              />
            </ListItem>
          </List>
          <Box sx={modalButtonsBoxStyle}>
            <Button
              onClick={handleCloseModal}
              variant='outlined'
              sx={adHocModalStyle}
              color='secondary'
            >
              {adHocReportingConstants.title.ADHOC_REPORTING_MODAL_CANCEL_BUTTON}
            </Button>
            <Button
              onClick={handleRunAdHocReport}
              sx={adHocModalStyle}
              variant='contained'
              color='secondary'
            >
              {adHocReportingConstants.title.ADHOC_REPORTING_MODAL_REDIRECT_BUTTON}
            </Button>
          </Box>
        </Box>
      </CenteredContainer>
    </Modal>
  )
}

AdHocReportModal.propTypes = {
  reportingRedirectUrl: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
}

export default AdHocReportModal
